import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

fetch('assets/appsettings.json')
    .then((response) => response.json())
    .then((json) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.appConfig = json.AppConfig;
        import('./app/app.module').then(module => {
            platformBrowserDynamic().bootstrapModule(module.AppModule)
                .catch(err => console.log(err));
        });
    });
